// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sale-status[data-v-2642abd8] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 0.4rem;\n  white-space: nowrap;\n}\n.sale-status-price[data-v-2642abd8] {\n  opacity: 0.8;\n}", ""]);
// Exports
module.exports = exports;
